import { useEffect, useState } from "react"
import styled from "styled-components"
import Brand from "../components/Brand"
import SkeletonLoader from "../components/SkeletonLoader"
import CardCamarero from "../components/CardCamarero"
import CardInfoLike from "../components/CardInfoLike"
import ButtonLike from "../components/ButtonLike"
import ThankYouPage from "../components/ThankYouPage"

const VotingCard = ({
    name,
    avatar,
    onLike,
    resto,
    restoAddress,
    thanks,
    category,
    loading,
    errorPage = false,
    errorMessage = null,
    onSelection,
    country,
    almacenInfo,
    customQuestions = [],
}) => {
    const [thanksPage, setThanksPage] = useState(thanks)
    const [novoting, setNovoting] = useState(false)
    const [congratulation, setCongratulation] = useState(false)
    const [isLiking, setIsLiking] = useState(false)
    const [hasLiked, setHasLiked] = useState(false)

    useEffect(() => {
        setThanksPage(thanks);
    }, [thanks])

    const handleLike = async () => {
        if (isLiking || hasLiked) return; // Prevenir múltiples clicks

        try {
            setIsLiking(true);
            // Bloquear inmediatamente para evitar múltiples clicks
            setHasLiked(true);

            // Forzar espera mínima de 1s para asegurar que el usuario vea el feedback
            // especialmente útil si la respuesta es muy rápida o falla instantáneamente
            const [result] = await Promise.all([
                onLike(),
                new Promise(resolve => setTimeout(resolve, 1000))
            ]);

            if (result?.success) {
                setThanksPage(true);
            } else if (result?.error) {
                // El error ya se maneja en el hook
                console.error("Error al dar like:", result.error);
            }
        } catch (error) {
            console.error("Error al dar like:", error);
        } finally {
            setIsLiking(false);
        }
    }

    const onNoVoting = () => {
        setNovoting(true)
        setThanksPage(true)
    }

    const onThanksPage = (value) => {
        setCongratulation(value)
    }

    const Wrapper = ({ children }) => (
        <>
            <HeaderWrap>
                <Brand
                    country={country}
                    width="220"
                    height="48"
                    showCokeLogo
                />
            </HeaderWrap>
            <CardCamarero
                category={category}
                name={name}
                resto={resto}
                restoAddress={restoAddress}
                avatar={avatar}
                loading={loading}
            />
            {children}
        </>
    )

    const ErrorComponent = () => (
        <ErrorWrap>
            <div>
                <h4>¡Ups!</h4>
                <h6>
                    {errorMessage || "El código escaneado no es válido o el usuario no fue encontrado."}
                </h6>
                <h6 style={{ marginTop: "8px", fontSize: "14px" }}>
                    Por favor, verifica el QR e inténtalo nuevamente.
                </h6>
            </div>
        </ErrorWrap>
    )

    if (loading)
        return (
            <Wrapper>
                <SkeletonLoader
                    active={loading}
                    width="50%"
                    height="25px"
                    borderRadius="15px"
                    margin="25px 0 8px 0"
                />
                <SkeletonLoader
                    active={loading}
                    width="99%"
                    height="100px"
                    borderRadius="15px"
                    margin="0 0 15px 0"
                />
                <SkeletonLoader
                    active={loading}
                    width="99%"
                    height="400px"
                    borderRadius="15px"
                    margin="0 0 15px 0"
                />
            </Wrapper>
        )

    if (errorPage)
        return (
            <Wrapper>
                <ErrorComponent />
            </Wrapper>
        )

    if (thanksPage)
        return (
            <Wrapper>
                <ThankYouPage
                    congrats={congratulation}
                    noVoting={novoting}
                    onNoVoting={onNoVoting}
                    onSelection={onSelection}
                    onThanksPage={onThanksPage}
                    almacenInfo={almacenInfo}
                    customQuestions={customQuestions}
                />
            </Wrapper>
        )

    return (
        <Wrapper>
            <CardInfoLike loading={loading} />
            <ButtonLike
                handleLike={handleLike}
                onNoVoting={onNoVoting}
                loading={loading}
                processing={isLiking}
                hasLiked={hasLiked}
            />
        </Wrapper>
    )
}

export default VotingCard

/* ========== Styled Components ========== */

const HeaderWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  > div {
    min-height: 120px;
  }
`

const ErrorWrap = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 60px;

  h4 {
    margin: 0 0 8px 0;
    font-weight: 700;
    color: #111827;
  }

  h6 {
    margin: 0;
    font-weight: 500;
    color: #6b7280;
    max-width: 360px;
  }
`
